<script>
    import { h } from 'vue';
    import getSlaLabel from '@/helpers/slaLabelsHelper';

    export default {
        name: 'SLADateFormat',
        props: {
            value: {
                type: [String, Number, Date, null],
                default: null
            },
            extraData: {
                type: null,
                default: null
            },
            valueText: {
                type: String,
                default: ''
            }
        },
        render() {
            if (!this.value) {
                return h('span');
            }

            const { labelClass, labelText } = getSlaLabel(this.value);

            return h(
                'span',
                {
                    class: labelClass,
                    title: labelText
                },
                this.valueText
            );
        }
    };
</script>

<style scoped>
    .label-blue {
        background-color: #2196f3;
    }

    .label-orange {
        background-color: #ff9f1a;
    }
</style>
